<template>
  <div v-if="data" class="info-page">
    <div class="info-page-body">
      <div class="info-page-body-top flex">
        <div v-if="data.coverImage" class="info-page-body-top-img flex-shrink" :style="{backgroundImage: 'url(' + data.coverImage + ')'}" />
        <div v-else class="info-page-body-top-img flex-shrink default-img-cover" />
        <div class="info-page-body-top-tit flex-1">
          <p class="font-24 tit">{{ data.title }}</p>
          <span v-if="data.author" class="item flex">
            <p class="font-14 key flex-shrink">著者：</p>
            <p class="font-14 value flex-1">{{ data.author }}</p>
          </span>
          <span v-if="data.source" class="item flex">
            <p class="font-14 key flex-shrink">来源：</p>
            <p class="font-14 value flex-1">{{ data.source }}</p>
          </span>
          <span v-if="data.recordTime" class="item flex">
            <p class="font-14 key flex-shrink">纪事时间：</p>
            <p :title="data.recordTime" class="font-14 value flex-1 text-line-2">{{ data.recordTime }}</p>
          </span>
          <span v-if="data.recordPlace" class="item flex">
            <p class="font-14 key flex-shrink">纪事地点：</p>
            <p :title="data.recordPlace" class="font-14 value flex-1  text-line-2">{{ data.recordPlace }}</p>
          </span>
          <span v-if="data.relatedPeople" class="item flex">
            <p class="font-14 key flex-shrink">纪事人物：</p>
            <p :title="data.relatedPeople" class="font-14 value flex-1  text-line-2">{{ data.relatedPeople }}</p>
          </span>
          <span v-if="data.recordOrg" class="item flex">
            <p class="font-14 key flex-shrink">纪事机构：</p>
            <p :title="data.recordOrg" class="font-14 value flex-1 text-line-2">{{ data.recordOrg }}</p>
          </span>
        </div>
      </div>
      <div class="info-page-body-files">
        <div class="info-page-body-files-head flex-row-center">
          <p class="line" />
          <p class="font-16 font-bold">馆藏文件</p>
        </div>
        <div v-for="(item, si) in data.files" :key="si" class="item flex-row-center-between">
          <span class="flex-row-center flex-1">
            <img :src="require('@/assets/img/icon-source-' + item.fileType + '.png')">
            <p class="font-14 tit text-line-1">{{ item.sourceFileName }}</p>
          </span>
          <p class="font-12 cursor btn flex-shrink" @click="tocheck(si)">查看</p>
        </div>
      </div>
    </div>
    <div class="info-page-body-des">
      <div class="info-page-body-files-head flex-row-center">
        <p class="line" />
        <p class="font-16 font-bold">馆藏介绍</p>
      </div>
      <div class="info-page-body-des-text">
        <p class="font-16 letter-spacing">{{ data.description }}</p>
      </div>
    </div>
    <div v-if="nextBook" class="info-page-body-bottom flex-row-center cursor">
      <p class="font-14" @click="toNext">下一篇：{{ nextBook.title }}</p>
    </div>
    <player ref="player" />
  </div>
</template>

<script>
import FileSaver from 'file-saver'
import { getShowPath } from '@/utils/imgpath.js'
import player from '@/components/player/index.vue'
import api from '@/api/source.js'
export default {
  components: {
    player
  },
  data() {
    return {
      nextBook: null,
      curIndex: 0,
      list: [],
      data: null,
      id: ''
    }
  },
  methods: {
    showInfo(curData, index, list) {
      this.data = curData
      this.list = list
      if (index + 1 < list.length) {
        this.nextBook = list[index + 1]
        this.curIndex = index
      } else {
        this.nextBook = null
      }
    },
    showInfoId(id, list) {
      this.id = id
      this.list = []
      this.list = this.list.concat(list)
      this.getDataId()
    },
    getDataId() {
      api.info({
        id: this.id
      }).then(res => {
        if (res.code === 2000) {
          res.items.coverImage = getShowPath('img', res.items.coverImage)
          res.items.files.forEach(v => {
            v.fileType = this.fileType(v.fileType)
            v.savePath = getShowPath(v.fileType, v.savePath)
          })
          this.data = res.items
          this.list.unshift(this.data)
          if (this.list.length > 1) {
            this.nextBook = this.list[1]
            this.curIndex = 0
          } else {
            this.nextBook = null
          }
        }
      })
    },
    getFileName(str) {
      return str.split('/').pop()
    },
    downFile() {
      const url = getShowPath('pdf', this.data.pdf)
      FileSaver.saveAs(url, this.data.bookName)
    },
    tocheck(val) {
      const data = this.data.files[val]
      if (data.fileType === 'img') {
        const ary = this.data.files.map(v => v.savePath)
        const index = ary.findIndex(v => v === data.savePath)
        this.$viewerApi({
          images: ary,
          options: {
            initialViewIndex: index
          }
        })
      } else if (data.fileType === 'pdf' || data.fileType === 'word') {
        window.open(data.savePath, '__blank')
      } else if (data.fileType === 'video' || data.fileType === 'audio') {
        const ary = this.data.files.filter(
          (v) => v.fileType === 'audio' || v.fileType === 'video'
        )
        console.log(ary)
        const index = ary.findIndex(v => v.id === data.id)
        this.$refs.player.showFull(ary, index)
        document.body.style.overflow = this.isFull ? 'hidden' : 'auto'
      }
    },
    fileType(str) {
      if (str) {
        if (str.indexOf('image') > -1) {
          return 'img'
        }
        if (str.indexOf('zip') >= 0) {
          return 'zip'
        }
        if (str.indexOf('video') >= 0) {
          return 'video'
        }
        if (str.indexOf('pdf') >= 0) {
          return 'pdf'
        }
        if (str.indexOf('audio') >= 0) {
          return 'audio'
        }
        if (str.indexOf('word') >= 0) {
          return 'word'
        }
        if (str.indexOf('xlsx') >= 0) {
          return 'xlsx'
        }
        if (str.indexOf('pptx') >= 0) {
          return 'ppt'
        }
      }

      return 'unkown'
    },
    toNext() {
      this.curIndex += 1
      if (this.curIndex + 1 < this.list.length) {
        this.nextBook = this.list[this.curIndex + 1]
      } else {
        this.nextBook = null
      }
      this.data = this.list[this.curIndex]
    }
  }
}
</script>

<style>

.info-page {
  padding: 20px 0 60px;
}

.info-page-body-top {
  margin-bottom: 30px;
}

.info-page-body-top-img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 340px;
  height: 240px;
  margin-right: 20px;
  border-radius: 3px;
}

.info-page-body-top-tit .tit {
  color: #1A1A1A;
  line-height: 36px;
  margin-bottom: 10px;
}

.info-page-body-top-tit .item .key {
  width: 80px;
  line-height: 32px;
  color: #767676;
}

.info-page-body-top-tit .item .value {
  line-height: 32px;
  color: #1A1A1A;
}

.info-page-body-files {
  margin-bottom: 30px;
}

.info-page-body-files-head {
  height: 50px;
}

.info-page-body-files-head .line {
  background: #B21F12;
  width: 4px;
  height: 16px;
  margin-right: 6px;
}

.info-page-body-files-head p {
  color: #B21F12;
}

.info-page-body-files-list {
  flex-wrap: wrap;
}

.info-page-body-files-list .item {
  width: calc(50% - 5px);
  height: 40px;
  border-radius: 5px;
  background: #F7F7F7;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 15px;
}

.info-page-body-files-list .item:nth-child(2n) {
  margin-right: 0;
}

.info-page-body-files-list .item img {
  margin-right: 10px;
}

.info-page-body-files-list .item .tit {
  color: #1A1A1A;
}

.info-page-body-files-list .item .btn {
  color: #767676;
  margin-left: 10px;
}

.info-page-body-des {
  margin-bottom: 30px;
}

.info-page-body-des-text p{
  line-height: 32px;
  color: #1A1A1A;
}

.info-page-body-bottom {
  margin-top: 60px;
  border-top: 1px solid #eee;
  height: 50px;
}

.info-page-body-bottom p {
  color: #1A1A1A;
}

</style>
